export default __webpack_public_path__ + "static/media/PublicisLogo.b9fed182.png";